import React, { Component } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import IntlMessages from 'util/IntlMessages';

class TitleInput extends Component {
    state={
      title:isEmpty(this.props.title)?0:this.props.title
    }
    getAvtalType=(e)=>{
        this.setState({
            title:e.target.value
        })
        this.props.onchangeHanelAktivitet("title",e.target.value)
    }
    render() {
        return (
          <TextField
              label={<IntlMessages id="userProfile.title"/>}
              variant="outlined"
              size="small"
              fullWidth
              value={this.state.avtaltype}
              onChange={this.getAvtalType}
          />
        );
    }
}

export default TitleInput;
